import React from 'react';
import {
  RankingOrderField,
  TextCollectionRankingOrderOption,
} from '@scale/shared/types/params/textcollection';
import { RankingOrderFieldAnnotation } from '@scale/shared/types/response/textcollection';
import FieldSection from './FieldSection';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

interface Props {
  rankingOrderOptions?: TextCollectionRankingOrderOption[];
  field: RankingOrderField;
  annotation: RankingOrderFieldAnnotation;
  setAnnotation: (annotation: RankingOrderFieldAnnotation) => void;
  disabled?: boolean;
  hideTitle?: boolean;
}

function RankingOrderFieldSection2(props: Props) {
  return (
    <DndProvider backend={HTML5Backend}>
      <FieldSection {...props} />
    </DndProvider>
  );
}

export default RankingOrderFieldSection2;
